import Modal from './Modal';

export default Modal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/shippingStatusEdit/index.jsx